import { router } from "@inertiajs/react";
import { useNewTaskFocus } from "@/stores/newTaskFocus";

interface Props {
  listId: string;
  href: string;
  name: string;
}

export default function SidebarQuickAdd({ listId, href, name }: Props) {
  function openNewTask() {
    useNewTaskFocus.getState().request(listId);
    if (window.location.pathname !== href) router.visit(href);
  }

  return (
    <button
      type="button"
      onClick={openNewTask}
      aria-label={`Новая задача в «${name}»`}
      title="Новая задача"
      className="sidebar-quick-add"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v14M5 12h14" />
      </svg>
    </button>
  );
}
